// components
import {
  styled,
  ToggleButtonGroupProps,
  Typography,
  TypographyProps
} from '@mui/material';
import { ControlledToggleButtonGroup } from 'components/shared/ControlledFields';

export const StyledHalfWidthTypography = styled(Typography)<TypographyProps>(
  () => ({
    width: '50%'
  })
);

export const StyledTitleTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
);

export const StyledSecondaryTitleTypography = styled(
  Typography
)<TypographyProps>(({ theme }) => ({
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(2)
}));

export const StyledControlledToggleButtonGroup = styled(
  ControlledToggleButtonGroup
)<ToggleButtonGroupProps>(() => ({
  '& .MuiButtonBase-root': {
    minWidth: '80px'
  }
}));
